import React from "react";
import { cn } from "@c4c-web/libs-hooks/libs";
import type { ILocation } from "../../../types";
import { AddressSelectorMap } from "./AddressSelectorMap";

interface IAddressSelectorContainerProps {
  countryOfOperationID: string;
  coordinates: ILocation;
  formattedAddress: string;
  id?: string;
  isAddressSelected: boolean;
  searchBarRef: React.RefObject<HTMLInputElement>;
  setIsAreaSupported: (isAreaSupported: boolean) => void;
  setAddressInfo: (addressInfo: string) => void;
  setCoordinates: (coordinates: ILocation) => void;
  setEmirate: (emirate: string) => void;
  setIsAddressSelected: (isSelected: boolean) => void;
  setTown: (town: string) => void;
  t: (key: string) => string;
}

export const AddressSelectorContainer: React.FC<
  IAddressSelectorContainerProps
> = ({
  countryOfOperationID,
  coordinates,
  formattedAddress,
  id,
  isAddressSelected,
  searchBarRef,
  setIsAreaSupported,
  setAddressInfo,
  setCoordinates,
  setEmirate,
  setIsAddressSelected,
  setTown,
  t,
}) => {
  return (
    <div
      className={cn("h-0 w-full opacity-0 cursor-default overflow-hidden", {
        "opacity-100 h-[100vh] mt-[10px] cursor-pointer": isAddressSelected,
      })}
    >
      <AddressSelectorMap
        countryOfOperationID={countryOfOperationID}
        defaultLocation={coordinates}
        formattedAddress={formattedAddress}
        id={id}
        onAreaSupportedChange={setIsAreaSupported}
        searchBarRef={searchBarRef}
        setAddressInfo={setAddressInfo}
        setCoordinates={setCoordinates}
        setEmirate={setEmirate}
        setIsSelected={setIsAddressSelected}
        setTown={setTown}
        t={t}
      />
    </div>
  );
};
